import { render, staticRenderFns } from "./LocationBasicDetail.vue?vue&type=template&id=1c07cb8b&"
import script from "./LocationBasicDetail.vue?vue&type=script&lang=js&"
export * from "./LocationBasicDetail.vue?vue&type=script&lang=js&"
import style0 from "./LocationBasicDetail.vue?vue&type=style&index=0&id=1c07cb8b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports